import { useEffect } from 'react';
import { observer } from 'mobx-react';

import { provide, useDependencies } from '@servicetitan/react-ioc';
import { Stack } from '@servicetitan/design-system';
import { Table, TableColumn } from '@servicetitan/table';

import { GlobalOptOutStore } from '../stores/global-opt-out.store';
import { DebouncedSearch } from '../../components/debounced-search/debounced-search';
import { OptInStatusFilter } from './opt-in-status-filter';
import { OptInToggleCell } from './opt-in-toggle-cell';

export const GlobalOptOut = provide({
    singletons: [GlobalOptOutStore],
})(
    observer(() => {
        const [store] = useDependencies(GlobalOptOutStore);

        useEffect(() => {
            store.init();
        }, [store]);

        return (
            <Stack direction="column" spacing={2}>
                <Stack direction="row" spacing={2} alignItems="flex-end">
                    <DebouncedSearch
                        onChange={store.filterByPhoneNumber}
                        externalValue={store.phoneNumberSearch}
                        placeholder="Search by Phone Number"
                    />
                    <OptInStatusFilter />
                </Stack>
                <Table
                    striped={false}
                    tableState={store.tableState}
                    loading={store.isLoading}
                    sortable
                >
                    <TableColumn field="phoneNumber" title="Phone Number" editable={false} />
                    <TableColumn cell={OptInToggleCell} editable={false} sortable={false} />
                </Table>
            </Stack>
        );
    }),
);
